export enum EmploymentStatus {
  HM = "Home Maker",
  SE = "Self Employed",
  W2 = "W2"
}

export const mapEmploymentStatus = (employment: string): EmploymentStatus => {
  const employmentMapping: { [key: string]: EmploymentStatus } = {
    HM: EmploymentStatus.HM,
    SE: EmploymentStatus.SE,
    W2: EmploymentStatus.W2,
  };

  return employmentMapping[employment] || undefined; 
};